<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>Settings</h2>
            <!-- <h3></h3> -->
        </div>
        <div slot="body">

            <div v-if="isLoading" class="m-4 text-center">
                <loader />
            </div>

            <div v-else>
                <div class="bg-color-1 lightest text-right p-4">
                    <div class="text-uppercase" v-if="getProductEditPriceData.audienceType">
                        Total per {{audienceIdToName(getProductEditPriceData.audienceType)}}
                    </div>
                    <div class="totalValue">
                        {{totalPVP}} €
                    </div>
                </div>

                <div class="p-5">
                    <split-price-editor></split-price-editor>
                </div>
            </div>


        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <div>
                <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                <button type="button" class="btn ok wider" @click="save">Save</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'
    import {eventHub} from '../../main'
    import SplitPriceEditor from '../../components/inventory/products/SplitPriceEditor'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data: function() {
            return {
                isLoadingExtras: false,
                isLoadingAudienceTypes: false,
            }
        },
        updated: function() {
            //bus updates "ProductEdit" to update the pricing rows
            eventHub.$emit('forceUpdate');
        },
        methods: {
            ...mapActions([
                'closeModal'
            ]),
            cancel: function() {
                this.closeModal();
            },
            save: function() {
                this.closeModal();
            },
            updateExtra: function(service) {
            },
            taxIdToName: function(taxId){
                if(this.taxes){
                    return this.taxes.filter((tax) => {
                        return tax.id == taxId
                    })[0].description
                }
            },
            audienceIdToName: function(audienceId){
                if(this.audienceTypes){
                    return this.audienceTypes.filter((audience) => {
                        return audience.id == audienceId
                    })[0].description
                }
            },
            addRow: function() {
                let defaultRow = {
                    "component": JSON.parse(JSON.stringify(this.extras[0])),
                    "isMandatory": 0
                }

                this.getProductEditPriceData.productGenderPriceComponents.push(defaultRow)
            },
            removePrice: function(index) {
                this.getProductEditPriceData.productGenderPriceComponents.splice(index, 1);
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getProductEditPriceData',
                'gisLoadingetVatTypes'
            ]),
            isLoading: function () {
                return this.isLoadingExtras || this.isLoadingAudienceTypes
            },
            taxes: function () {
                return this.getVatTypes
            },
            totalPVP: function() {
                let total = 0;
                for (let service of this.getProductEditPriceData.productGenderPriceComponents) {
                    if(service.component.selectedPrice){
                        total += service.component.selectedPrice.grossprice
                    }
                }
                return (total).toFixed(2).replace(".", ",");
            }
        },
        asyncComputed: {
            async extras() {
                try {
                    this.isLoadingExtras = true;
                    let response = await axios.get('/api/inventory/ListExtra', { params: { supplierId: this.account.supplierId }});

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        this.isLoadingExtras = false;

                        return response.data;
                    }
                }
                catch (error) {
                    this.isLoadingExtras = false;
                    this.$toasted.error(error);
                }
            },
            async audienceTypes() {
                try {
                    this.isLoadingAudienceTypes = true;
                    let response = await axios.get('/api/settings/GetAudienceTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {

                        this.isLoadingAudienceTypes = false;
                        return response.data;
                    }
                }
                catch (error) {
                    this.isLoadingAudienceTypes = false;
                    this.$toasted.error(error);
                }
            },
        },
        components: {
            Modal,
            vSelect: extendedVSelect,
            SplitPriceEditor,
            Loader,
        }
    }
</script>

<style>
    .totalValue{
        font-size: 3rem;
    }
</style>



// WEBPACK FOOTER //
// ProductEditPrice.vue?c5be1886